// Enums
import { EnvName } from '@enums/environment.enum';
import { LogLevel } from '@services/logger.service';
// Packages
import packageInfo from '../../package.json';

const scheme = 'https://';
const host = 'test.sensika.com';
const rootUrl = scheme + host;
const port = '';
const path = '/api/v1.0';

const baseUrl = scheme + host + port + path;
const baseUrlEnvironmentSuffix = '';

export const environment = {
  production: true,
  host: host,
  scheme: scheme,
  path: '',
  schemeWS: 'wss://',
  hostWS: host,
  portWS: ':443',
  pathWS: '/ws',
  logLevel: 'debug' as LogLevel,
  version: packageInfo.version,
  appName: 'Sensika',
  envName: EnvName.TEST,
  defaultLanguage: 'en',
  baseUrl: rootUrl,
  baseUrlEnvironmentSuffix: baseUrlEnvironmentSuffix,
  apiBaseUrl: baseUrl,

  // new vars
  sensikaPath: '/',
  sensikaSysAppDomain: 'https://test.sensika.com', // Used in HTML templates
  sensikaAdministrationUrl: 'https://scp.sensika.com/admin/',
  debugInfoEnabled: true,
  errorOnUnhandledRejections: true,

  sensikaFacebookLoginUrl: 'https://test.sensika.com/oauth/12/authorize',
  sensikaSamlLoginUrl: 'https://test.sensika.com/saml/2/authorize',
};
